module.exports = __webpack_public_path__ + "media/images/lb/075-eea446f186382eedcfd4921b14ac075c.svg";